import { Dispatch } from 'redux';
import { fetchCurrentMenu, storeCurrentWarehouse } from '../services/warehouse';
import { CurrentMenu } from '../services/typings';
import {
  WAREHOUSE_FETCHING,
  WAREHOUSE_RECEIVED,
  WAREHOUSE_ERROR,
  WAREHOUSE_SELECTED,
  PRODUCT_SEARCH,
} from './warehouse-action-types';

interface WarehouseIsFetchingAction {
  type: 'WAREHOUSE_FETCHING';
}

interface WarehouseFetchErrorAction {
  type: 'WAREHOUSE_ERROR';
  error: Error;
}

interface WarehouseContentReceivedAction {
  type: 'WAREHOUSE_RECEIVED';
  payload: CurrentMenu;
}

interface WarehouseSelectedAction {
  type: 'WAREHOUSE_SELECTED';
  warehouseId: number;
  warehouseName: string;
}

interface WarehouseProductSearchAction {
  type: 'PRODUCT_SEARCH';
  text: string;
}

export type WarehouseAction =
  | WarehouseIsFetchingAction
  | WarehouseFetchErrorAction
  | WarehouseContentReceivedAction
  | WarehouseSelectedAction
  | WarehouseProductSearchAction;

const warehouseIsFetching = (): WarehouseIsFetchingAction => ({
  type: WAREHOUSE_FETCHING,
});

const warehouseFetchError = (error: Error): WarehouseFetchErrorAction => ({
  type: WAREHOUSE_ERROR,
  error,
});

const warehouseContentReceived = (payload: CurrentMenu): WarehouseContentReceivedAction => ({
  type: WAREHOUSE_RECEIVED,
  payload,
});

export const warehouseSelected = (
  warehouseId: number,
  warehouseName: string,
): WarehouseSelectedAction => ({
  type: WAREHOUSE_SELECTED,
  warehouseId,
  warehouseName,
});

export const productSearch = (text: string): WarehouseProductSearchAction => ({
  type: PRODUCT_SEARCH,
  text,
});

export const selectWarehouseAction = (warehouseId: number, warehouseName: string) => async (
  dispatch: Dispatch,
) => {
  dispatch(warehouseSelected(warehouseId, warehouseName));
  dispatch(warehouseIsFetching());
  storeCurrentWarehouse(warehouseId, warehouseName);
  try {
    const customMenu = await fetchCurrentMenu(warehouseId);
    dispatch(warehouseContentReceived(customMenu));
  } catch (error) {
    dispatch(warehouseFetchError(error));
  }
};
